<script>
  // ══════════════════════════════════════════════════════════════════════════
  // АНИМАЦИИ ПЕРСОНАЖА — перенос anims.tsx 1:1: 7 категорий + «Магазин» +
  // «Избранное», 712 позиций; превью — настоящий кадр анимации с зеркала CDN.
  // Клик по платной некупленной = ПОКУПКА, по остальным = запуск; звезда —
  // избранное; остановка — «Пробел» (ловит клиент) и кнопка.
  // ══════════════════════════════════════════════════════════════════════════
  import { t } from '../../i18n.js';
  import { num } from '../partsfn.js';
  import { ANIM_CATS, ANIM_TOTAL, animPhoto } from '../anims.js';
  import Ico from '../ico.svelte';
  import Empty from '../empty.svelte';
  import Photo from '../photo.svelte';
  import Scroll from '../ui/scroll.svelte';
  import Sechead from '../ui/sechead.svelte';
  import Panel from '../ui/panel.svelte';
  import Chip from '../ui/chip.svelte';
  import GoldBtn from '../ui/goldbtn.svelte';
  import GhostBtn from '../ui/ghostbtn.svelte';
  import SlotTabs from '../ui/slottabs.svelte';
  import Search from '../ui/search.svelte';
  import Jc from '../ui/jc.svelte';

  export let state = {};
  export let balance = 0;
  export let nui = () => {};

  /** Сколько карточек рисуем за раз: в «Эксклюзивных» почти 500 — все сразу CEF не нужны. */
  const CHUNK = 120;
  /** Значок категории — по смыслу названия из каталога. */
  const CAT_ICO = {
    action: 'hand', pose: 'anims', positive: 'heart', negative: 'no',
    dances: 'music', etc: 'menu', exclusive: 'battlepass',
  };

  let cat = 'action';
  let q = '';
  let limit = CHUNK;
  let playing = null;

  $: purchased = new Set(state.purchased ?? []);
  $: favourites = new Set(state.favourites ?? []);

  /** Плоский список всех анимаций — нужен «Магазину» и «Избранному». */
  const all = ANIM_CATS.flatMap((c) => c.items);

  $: list = (() => {
    let src;
    if (cat === 'shop') src = all.filter((a) => a.p > 0 && !purchased.has(a.k));
    else if (cat === 'fav') src = all.filter((a) => favourites.has(a.k));
    else {
      const c = ANIM_CATS.find((x) => x.id === cat);
      // как в оригинале: платную некупленную в обычной категории не показываем
      src = (c?.items ?? []).filter((a) => a.p === 0 || purchased.has(a.k));
    }
    const s = q.trim().toLowerCase();
    return s ? src.filter((a) => a.n.toLowerCase().includes(s)) : src;
  })();

  let _lk = '';
  $: { const k = cat + '|' + q; if (k !== _lk) { _lk = k; limit = CHUNK; } }

  $: tabs = [
    ...ANIM_CATS.map((c) => ({
      id: c.id, label: c.name, icon: CAT_ICO[c.id] || 'anims',
      n: c.items.filter((a) => a.p === 0 || purchased.has(a.k)).length,
    })),
    { id: 'shop', label: t('m.an.shop'), icon: 'cart', n: all.filter((a) => a.p > 0 && !purchased.has(a.k)).length },
    { id: 'fav', label: t('m.an.fav'), icon: 'star', n: favourites.size },
  ];

  const run = (a) => {
    const own = a.p === 0 || purchased.has(a.k);
    if (!own) { nui('animBuy', { key: a.k }); return; }
    playing = a.k;
    nui('animPlay', { key: a.k });
  };
  const stop = () => { playing = null; nui('animStop'); };
</script>

<div class="mn-fill">
  <div class="head">
    <Sechead kicker={t('m.an.kicker')} title={t('m.an.title')} meta={t('m.an.of', { n: num(list.length), all: num(ANIM_TOTAL) })} />
    <div class="mn-tools">
      <div class="grow"><Search value={q} onChange={(v) => (q = v)} placeholder={t('m.an.find')} /></div>
      {#if playing}
        <GoldBtn size="sm" on:click={stop}><Ico n="stop" s={15} />{t('m.an.stop')}</GoldBtn>
      {:else}
        <GhostBtn size="sm" on:click={stop}><Ico n="stop" s={15} />{t('m.an.stop')}</GhostBtn>
      {/if}
      <Chip><Ico n="keyboard" s={14} />{t('m.an.space')}</Chip>
    </div>
    <SlotTabs items={tabs} active={cat} onChange={(id) => (cat = id)} />
  </div>

  <div class="body">
    {#if list.length === 0}
      <Panel><Empty icon="anims" text={q ? t('m.nothingFound') : t('m.an.none')} /></Panel>
    {:else}
      <Scroll>
        <div class="mn-anims">
          {#each list.slice(0, limit) as a (a.k)}
            {@const own = a.p === 0 || purchased.has(a.k)}
            {@const fav = favourites.has(a.k)}
            <div
              class={'mn-anim' + (playing === a.k ? ' on' : '')}
              on:click={() => run(a)}
              title={own ? t('m.an.play') : t('m.buy')}
            >
              <div
                class={'fav' + (fav ? ' on' : '')}
                on:click|stopPropagation={() => nui('animFav', { key: a.k })}
                title={t('m.an.fav')}
              >
                <Ico n="star" s={14} />
              </div>
              {#if !own}<div class="tag"><Ico n="currency" s={12} />{num(a.p)}</div>{/if}
              <Photo src={animPhoto(a)} alt={a.n} icon="anims" />
              <div class="marks">
                {#if a.mus}<Ico n="music" s={13} />{/if}
                {#if a.prop}<Ico n="cases" s={13} />{/if}
                {#if a.pair}<Ico n="users" s={13} />{/if}
                {#if a.loop}<Ico n="reset" s={13} />{/if}
              </div>
              <div class="nm">{a.n}</div>
            </div>
          {/each}
        </div>

        {#if list.length > limit}
          <div style="display:flex;justify-content:center;margin-top:var(--mn-gap)">
            <GhostBtn size="sm" on:click={() => (limit = limit + CHUNK)}>
              <Ico n="down" s={15} />{t('m.an.more', { n: num(list.length - limit) })}
            </GhostBtn>
          </div>
        {/if}

        {#if cat === 'shop'}
          <div class="hint" style="margin-top:var(--mn-gap)">
            {t('m.an.shopHint')} · {t('m.balance')}: <b><Jc v={balance} /></b>
          </div>
        {/if}
      </Scroll>
    {/if}
  </div>
</div>
